import {
  calculateDateRange as calculateSharedDateRange,
  formatDateLabel,
} from "../../Shared/Utils/dateRanges";

export { formatDateLabel };

const pad = (value) => String(value).padStart(2, "0");

const formatDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const getLastDayOfMonth = (date) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0);

export const calculateDateRange = (range) => {
  const { fromDate, toDate } = calculateSharedDateRange(range);
  return { newFromDate: fromDate, newToDate: toDate };
};

export const getEndOfMonth = (dateString, groupBy = "month") => {
  try {
    let date;
    if (dateString && /^\d{4}-\d{2}$/.test(dateString)) {
      date = new Date(`${dateString}-01T00:00:00`);
    } else if (dateString) {
      date = new Date(`${dateString}T00:00:00`);
    } else {
      date = new Date();
    }

    const finalDate =
      groupBy === "year"
        ? new Date(date.getFullYear(), 11, 31)
        : getLastDayOfMonth(date);

    return formatDate(finalDate);
  } catch {
    return new Date().toISOString().split("T")[0];
  }
};

export const getStartOfPeriod = (dateString, groupBy = "month") => {
  try {
    if (!dateString) {
      return new Date(new Date().getFullYear(), 0, 1).toISOString().split("T")[0];
    }

    const baseDate = new Date(`${dateString}T00:00:00`);
    if (Number.isNaN(baseDate.getTime())) return dateString;

    if (groupBy === "year") {
      return `${baseDate.getFullYear()}-01-01`;
    }

    return `${baseDate.getFullYear()}-${pad(baseDate.getMonth() + 1)}-01`;
  } catch {
    return dateString;
  }
};
